import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";
import { InnerHeader } from "@/components/features/items/edit/plan/standard-plan/default/ui/_shared/components/email/inner-header";

import { QuestionDayTripPlanEmailTemplates } from "./email-templates";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	email: DayTripPlanCategoriesAndManagerStore["email"];
	name: string;
	hotelID: string;
};

export const QuestionDayTripPlanEmail = ({ email, name, hotelID }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="メール設定" categoryStore={email}>
				<InnerHeader hotelID={hotelID} planName={name} />
			</FeatureIslandMainWithCategoryWrapper>
			<QuestionDayTripPlanEmailTemplates email={email} />
		</>
	);
};

QuestionDayTripPlanEmail.displayName = "QuestionDayTripPlanEmail";
